export const environment = {
  production: false,
  staging: true,

  apiBaseUrl: 'https://imsapi.unpluggits.co.za/api',
  apiUrl: 'https://imsapi.unpluggits.co.za/api',

  useMockData: false,
  peekDevOtp: false,
};
